import { createEnum } from "@redotech/redo-model/common/zod-util";
import { RedoShopifyOrderCancelReason } from "@redotech/redo-model/fulfillments/order-cancel-reason";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const cancelFulfillmentGroups = {
  name: "cancelFulfillmentGroups" as const,
  input: z.object({
    fulfillmentGroupIds: z.array(zExt.objectId()),
    reason: createEnum(RedoShopifyOrderCancelReason).nullish(),
    notifyCustomer: z.boolean().nullish(),
    refund: z.boolean().nullish(),
    restock: z.boolean().nullish(),
  }),
  output: z.null(),
};
